var langs = ['en', 'es'];
var langCode = 'en';
var langJS = null;


var translate = function (jsdata)
{	
	$("[tkey]").each (function (page)
	{
		var strTr = jsdata [$(this).attr ('tkey')];
	    $(this).html (strTr);
	});
}






